<template>
  <div class="row push">
    <div class="col-md-6 col-lg-5 col-xl-4 order-md-1">
      <div class="alert alert-danger d-flex align-items-center justify-content-between mb-0" role="alert" v-if="!canpay">
        <div class="flex-00-auto">
          <i class="fa fa-fw fa-times-circle"></i>
        </div>
        <div class="flex-fill mr-3">
          <p class="mb-0">Uw factuurgegevens ontbreken. Klik <a class="alert-link" :href="$route('profile.edit')">hier</a> om deze toe te voegen.</p>
        </div>
      </div>
      <!-- Shopping Cart -->
      <div class="block block-mode-loading-oneui">
        <div class="block-header block-header-default">
          <h3 class="block-title">Huidig saldo</h3>
        </div>
        <div class="block-content">
          <div class="row mb-3">
            <div class="col">Uw huidige saldo inclusief btw</div>
            <div class="col text-right font-weight-bold">{{ current | currency }}</div>
          </div>
        </div>
      </div>
      <div class="block block-mode-loading-oneui" id="orderblock">
        <div class="block-header block-header-default">
          <h3 class="block-title">Bestelling</h3>
        </div>
        <div class="block-content" v-if="amount > 0 && amount_including > 0">
          <div class="row">
            <div class="col">Saldo</div>
            <div class="col text-right font-weight-bold">{{ amount | currency }}</div>
          </div>
          <div class="row">
            <div class="col">BTW</div>
            <div class="col text-right font-weight-bold" v-if="!vatfree">{{ (amount_including - amount) | currency }}</div>
            <div class="col text-right font-weight-bold" v-if="vatfree">Geen</div>
          </div>
          <hr />
          <div class="row align-items-center mb-3">
            <div class="col">
              <div class="font-weight-bold">Total</div>
              <div>Incl. BTW</div>
            </div>
            <div class="col text-right font-weight-bold h2 mb-0">{{ amount_including | currency }}</div>
          </div>
          <div class="alert alert-primary">
            <div class="row align-items-center">
              <div class="col">
                <div>Nieuw saldo na betaling</div>
              </div>
              <div class="col-4 text-right text-primary">{{ (current + parseFloat(amount_including)) | currency }}</div>
            </div>
          </div>
          <div class="form-group">
            <button class="btn btn-alt-success btn-block" v-on:click="order" :disabled="!canpay">
              Bestellen
            </button>
          </div>
        </div>
      </div>
      <!-- END Shopping Cart -->
    </div>
    <div class="col-md-6 col-lg-7 col-xl-8">
      <div class="block">
        <div class="block-header block-header-default">
          <h3 class="block-title">Saldo</h3>
        </div>
        <div class="block-content">
          <p class="font-size-sm text-muted">
            De links op onze website kunt u afrekenen met Mollie. Wij accepteren PayPal, overschrijving en iDeal. <br />
            Het is nu mogelijk om uw Saldo op te waarderen bij SEOtool.nl. Via onderstaande optie kunt u gemakkelijk een Saldo toevoegen aan ons
            systeem. Als u links betaald, worden deze betaald van uw Saldo.
          </p>
          <div class="form-group form-row">
            <div class="col-6">
              <bs-input label="Bedrag exclusief BTW" type="number" name="excluding" step=".01" v-model.number="amount"></bs-input>
            </div>
            <div class="col-6" v-if="!vatfree">
              <bs-input label="Bedrag inclusief BTW" type="number" name="including" step=".01" v-model.number="amount_including"></bs-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
export default {
  props: ['balance', 'vatfree', 'value', 'canpay'],
  data: () => {
    return {
      current: 0,
      amount: 0,
      amount_including: 0,
    };
  },
  created() {
    this.current = parseFloat(this.balance);
    if (this.vatfree) {
      this.amount = this.value;
    } else {
      this.amount_including = this.value;
    }
  },
  watch: {
    amount: _.debounce(function(val) {
      var including = parseFloat(val).toFixed(2);
      if (!this.vatfree) {
        including = parseFloat(val * 1.21).toFixed(2);
      }

      if (including != parseFloat(this.amount_including).toFixed(2)) {
        One.block('state_loading', '#orderblock');
        setTimeout(() => {
          One.block('state_normal', '#orderblock');
        }, 200);
        this.amount_including = including;
      }
    }, 500),
    amount_including: _.debounce(function(val) {
      var excluding = parseFloat(val).toFixed(2);
      if (!this.vatfree) {
        excluding = parseFloat(val / 1.21).toFixed(2);
      }

      if (excluding != parseFloat(this.amount).toFixed(2)) {
        One.block('state_loading', '#orderblock');
        setTimeout(() => {
          One.block('state_normal', '#orderblock');
        }, 200);
        this.amount = excluding;
      }
    }, 500),
  },
  methods: {
    order: function() {
      One.block('state_loading', '#orderblock');
      axios
        .post(route('profile.balance'), {
          amount: this.amount,
        })
        .then(function(response) {
          if (response.status == 200 && response.data && response.data.success) {
            One.block('state_normal', '#orderblock');
            if (response.data.redirect) {
              window.location.href = response.data.redirect;
            }
          }
        });
    },
  },
};
</script>
